import { AppRoutes } from '@/routes'
import type { UserProfile } from '@/features/Auth/auth.types'
import { getUser } from '@/features/Auth/auth.utils'
import { getLocalStorage } from '@/shared/helpers/localStorage'
import { hasEmail, hasPhone, isKycApproved, isKycPending } from '@/features/User/user.selectors'

export function isLimitReached(canIssue: boolean, canIssueReason?: string[] | null): boolean {
  return !canIssue && !!canIssueReason && (canIssueReason.includes('FREE_LIMIT_HAS_REACHED') || canIssueReason.includes('HARD_LIMIT_HAS_REACHED'))
}

export function computeCardsRoute(
  profile: UserProfile | null | undefined,
  canIssueCard: boolean,
  canIssueCardReason: string[],
  pathname: string,
  hasExistingCards: boolean = false,
): string {
  const cardRulesAccepted = hasExistingCards
    || (typeof window !== 'undefined' ? getLocalStorage('godefi:card:rules:accepted') : null)
  const isIdentificationPage = pathname === AppRoutes.KYC_V2_PAGE
  const kycApproved = isKycApproved(profile)

  if (!hasEmail(profile) || !hasPhone(profile) || isKycPending(profile)) return AppRoutes.KYC_V2_PAGE
  if (!kycApproved && !isIdentificationPage) return AppRoutes.KYC_V2_PAGE
  if (kycApproved && isLimitReached(canIssueCard, canIssueCardReason)) return AppRoutes.CARDS_SUBSCRIPTION_PAGE
  if (canIssueCardReason.includes('ACCEPT_TERMS') || !cardRulesAccepted) return AppRoutes.CARDS_RAIN_RULES

  return AppRoutes.CARDS_TOKEN_PAGE
}

export async function getCardDetails(cardId: string) {
  const user = getUser()
  if (!user?.accessToken) throw new Error('Not authenticated')
  return await fetch(`/api/rain?cardId=${cardId}`, {
    headers: {
      Authorization: `Bearer ${user.accessToken}`
    }
  })
}
